import { RootState, store } from 'modules/Editor/store';
import { selectWidgetLayerOrder, selectWidgets } from 'modules/Editor/store/infographSelector';
import { PageId } from 'types/idTypes';
import { InteractiveElement } from 'types/interactiveWidget.types';
import { hasInteraction } from 'widgets/sdk/Toolbar/InteractiveMenu/InteractiveMenu.helpers';

/**
 * Check if the page has interactive elements.
 *
 * @param pageId
 * @returns boolean TRUE if the page has interactive elements, FALSE otherwise
 */
export const checkPageHasInteractiveElements = (pageId: PageId): boolean => {
  const storeState = store.getState() as RootState;
  const widgetOrder = selectWidgetLayerOrder(pageId)(storeState);
  const widgets = selectWidgets(storeState);
  const hasInteractiveElements = widgetOrder.some((widgetId) => {
    const widget = widgets[widgetId];
    return hasInteraction((widget as InteractiveElement)?.interactions);
  });

  return hasInteractiveElements;
};
